<kendo-dialog *ngIf="isAcceptOrStartCallDecisionRequired$ | async" (close)="cancel()" [minWidth]="250" [width]="450">
   <kendo-dialog-titlebar>
      {{ 'samwin.accept-or-dial-dialog.title' | translate }}
   </kendo-dialog-titlebar>

   <div fxLayout="column">
      <div fxFlex="1 2 0" class="info-text-box">
         {{ 'samwin.accept-or-dial-dialog.question' | translate }}
      </div>

      <ng-container *ngIf="callInfo$ | async as callInfo">
         <div fxFlex="1 2 0" class="call-info-description">
            <div fxFlex="20" class="call-info-description-text">
               {{ 'samwin.accept-or-dial-dialog.ringing-call' | translate }}
            </div>
            <samweb-peer-info fxFlex="80" [call]="callInfo"></samweb-peer-info>
         </div>
      </ng-container>

      <ng-container *ngIf="nextDialTarget$ | async as dialTarget">
         <div fxFlex="1 2 0" class="call-info-description">
            <div fxFlex="20" class="call-info-description-text">
               {{ 'samwin.accept-or-dial-dialog.dial-target' | translate }}
            </div>
            <samweb-peer-info fxFlex="80" [call]="dialTarget | dialTargetToPeerInfo"></samweb-peer-info>
         </div>
      </ng-container>
   </div>

   <kendo-dialog-actions>
      <button kendoButton (click)="accept()">
         <fa-icon [icon]="phoneAnswerIcon" class="sam-margin-right"></fa-icon>
         {{ 'common.calling.accept' | translate }}
      </button>
      <button kendoButton (click)="dial()" primary="true">
         <div class="fa-layers sam-margin-right">
            <fa-icon [icon]="dialArrowIcon" transform="shrink-8 right-4 up-6"></fa-icon>
            <fa-icon [icon]="phoneAnswerIcon"></fa-icon>
         </div>
         {{ 'samwin.accept-or-dial-dialog.dial' | translate }}
      </button>
   </kendo-dialog-actions>
</kendo-dialog>
